<template>
  <div>
    <div>
      <b-form  ref="form" :style="{height: trHeight}" class="repeater-form">

        <!-- Row Loop -->
        <b-row v-for="(item, index) in items" :id="item.id" :key="item.id" ref="row">
          <b-col md="12" xl="12" class="mb-1">
            <b-row>

              <b-col cols="6" md="2" xl="2">
                <b-form-group :label="$t('import from file')" :label-for="'containers_excl_file' + item.id" :state="null">
                  <b-form-file locale="ar" :id="'containers_excl_file'+item.id"

                               @change="onFileChange(index, $event)"
                               dir="ltr"
                               :placeholder="$t('select file')"
                               drop-placeholder="Drop file here..." />

                  <p class="text-danger" v-if="errors && ('data.' + index +'.containers_file') in errors">
                    {{ $t(cleanValidationMessage(errors[`data.${index}.containers_file`][0])) }}
                  </p>

                </b-form-group>
              </b-col>

              <b-col cols="6" md="1" xl="1">
                <b-form-group :label="$t('containers count')">
                  <b-form-input :value="item.count" disabled /></b-form-group>
              </b-col>

              <b-col md="3" xl="3">
                <b-form-group :label="$t('select work area')" :label-for="'work_area_' + item.id" :state="null">
                <v-select multiple :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :reduce="val => val.geofence_id"
                          label="name" :options="workAreasOptions"
                          v-model="item.paths"
                         />

                  <p class="text-danger" v-if="errors && ('data.' + index +'.paths') in errors">
                    {{ $t(cleanValidationMessage(errors[`data.${index}.paths`][0])) }}
                  </p>
                </b-form-group>

              </b-col>

              <b-col md="3" xl="2">
                <b-form-group :label="$t('select week')" :label-for="'week_' + item.id" :state="null">
                  <v-select multiple :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :reduce="val => val.value"
                            label="text" :options="week_ordinaries"
                            v-model="item.week_ordinaries"
                            />

                  <p class="text-danger" v-if="errors && ('data.' + index +'.week_ordinaries') in errors">
                    {{ $t(cleanValidationMessage(errors[`data.${index}.week_ordinaries`][0])) }}
                  </p>
                </b-form-group>
              </b-col>

              <b-col md="3" xl="3">
                <b-form-group :label="$t('select week days')" :label-for="'week_day_' + item.id" :state="null">
                  <v-select multiple :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :reduce="val => val.value"
                            label="text" :options="week_days" v-model="item.week_days"/>

                  <p class="text-danger" v-if="errors && ('data.' + index +'.week_days') in errors">
                    {{ $t(cleanValidationMessage(errors[`data.${index}.week_days`][0])) }}
                  </p>

                </b-form-group>

              </b-col>


              <!-- Remove Button -->
              <b-col md="1" style="display: flex; align-items: center" class="mb-50 pl-0 pr-0">
                <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-danger" class="mt-0 mt-md-0 btn-sm" @click="removeItem(index)">
                  <feather-icon icon="XIcon" class="mr-25"/>
                </b-button>
              </b-col>
            </b-row>

<!--            <slot name="error"></slot>-->
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="repeatAgain">
              <feather-icon icon="PlusIcon" class="mr-25"/>
              <span>{{ $t('Add Row')}}</span>
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </div>

  </div>
</template>

<script>

import vSelect from 'vue-select'
import Repeater from '@/@core/mixins/ui/repeater'
import { BForm, BFormGroup, BFormInput, BRow, BCol, BButton, BFormFile, BFormInvalidFeedback } from 'bootstrap-vue'

import { nextTick, onMounted, onUnmounted, ref, toRefs, watch } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'


export default {
  components: {
    BFormInvalidFeedback,
    vSelect,
    BForm, BRow, BCol, BButton, BFormGroup, BFormInput,BFormFile
  },
  directives: { Ripple, },
  props: {
    errors: Object,
    week_ordinaries: {type: Array},
    week_days: {type: Array},
    workAreasOptions: { type: Array },
    items: { type: Array, }
  },

  setup(props, {root, emit}) {

    const form = ref(null)
    const row = ref(null)

    const { trHeight, trAddHeight, trTrimHeight, trSetHeight } = Repeater()

    window.addEventListener('resize', initTrHeight)
    onMounted(() => initTrHeight())
    onUnmounted(() => window.removeEventListener('resize', initTrHeight))

    const initTrHeight = () => {
      trSetHeight(null)
      nextTick(() =>  trSetHeight(form.scrollHeight))
    }

    const removeItem = (index) => {
      props.items.splice(index, 1)
      trTrimHeight(row.value[0].offsetHeight)
    }

    const repeatAgain = () => {
      props.items.push({
        id: Date.now(),
        paths: [],
        week_days: [],
        week_ordinaries: [],
        container_file: null,
      })

      nextTick(() => trAddHeight(row.value[0].offsetHeight))
    }

    const onFileChange = (index, event) => {
      props.items[index].containers_file = event.target.files[0]
    }

    const cleanValidationMessage = message => {
      if (typeof message !== 'string') return message;
      // Remove any .number. pattern from the message
      return message.replace(/\.\d+\./g, '.');
    }

    return {
      form,
      row,
      trHeight,
      repeatAgain, onFileChange,
      removeItem, cleanValidationMessage
    }

  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow:  visible !important;
  transition: .35s height;
}

.text-danger {
  font-size: 0.857rem;
}
</style>
